import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

interface IProps {
    Modal: boolean
    HideModal: any
    EstadoRegla: any
}

interface IState {
    Copied: boolean
}

export default class ModalEstado extends React.Component<IProps, IState> {

    constructor(props : any){
        super(props)
        this.state = { Copied: false }
    }

    FormatearFecha(fecha: any){
        if(!fecha) return '—'
        var d = new Date(fecha)
        return d.toLocaleDateString('es-ES', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        })
    }

    ObtenerEstado(){
        if(!this.props.EstadoRegla) return { label: 'Sin información', icon: 'pi pi-info-circle', color: '#6b7280', bg: '#f3f4f6' }
        var codigo = this.props.EstadoRegla.Codigo
        if(codigo === '0') return { label: 'Sincronizado', icon: 'pi pi-check-circle', color: '#166534', bg: '#dcfce7' }
        if(codigo === '-1') return { label: 'No Sincronizado', icon: 'pi pi-exclamation-triangle', color: '#854d0e', bg: '#fef9c3' }
        return { label: 'Error', icon: 'pi pi-times-circle', color: '#991b1b', bg: '#fef2f2' }
    }

    CopiarDetalle = () => {
        var texto = this.props.EstadoRegla ? this.props.EstadoRegla.Detalle : ''
        navigator.clipboard.writeText(texto)
        this.setState({ Copied: true })
        setTimeout(() => this.setState({ Copied: false }), 2000)
    }

    RenderFooter(){
        return (
            <Button label="Cerrar" icon="pi pi-check" onClick={this.props.HideModal} autoFocus />
        )
    }

    render(){
        var estado = this.ObtenerEstado()
        var regla = this.props.EstadoRegla
        var mensaje = regla ? (regla.Mensaje === '' ? 'Falta Sincronización' : regla.Mensaje) : 'Falta Sincronización'
        var detalle = regla ? regla.Detalle : ''

        return (
            <Dialog
                header="Detalle de sincronización"
                visible={this.props.Modal}
                style={{ width: '680px' }}
                footer={this.RenderFooter()}
                onHide={this.props.HideModal}
                className="modal-sync">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                        <div style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px 16px',
                            borderRadius: '20px',
                            background: estado.bg,
                            color: estado.color,
                            fontWeight: 600,
                            fontSize: '14px',
                            alignSelf: 'flex-start'
                        }}>
                            <i className={estado.icon} style={{ fontSize: '16px' }}></i>
                            {estado.label}
                        </div>

                        <div style={{ display: 'flex', gap: '20px' }}>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontSize: '12px', fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '6px' }}>Código</div>
                                <div style={{
                                    padding: '10px 14px',
                                    background: '#f9fafb',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    fontSize: '15px',
                                    fontWeight: 600,
                                    color: '#1f2937',
                                    fontFamily: 'monospace'
                                }}>
                                    {regla ? regla.Codigo : '—'}
                                </div>
                            </div>
                            <div style={{ flex: 2 }}>
                                <div style={{ fontSize: '12px', fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '6px' }}>Fecha de Proceso</div>
                                <div style={{
                                    padding: '10px 14px',
                                    background: '#f9fafb',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    color: '#374151'
                                }}>
                                    {this.FormatearFecha(regla ? regla.FechaProceso : null)}
                                </div>
                            </div>
                        </div>

                        <div>
                            <div style={{ fontSize: '12px', fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: '6px' }}>Mensaje</div>
                            <div style={{
                                padding: '12px 14px',
                                background: '#f9fafb',
                                border: '1px solid #e5e7eb',
                                borderRadius: '8px',
                                fontSize: '14px',
                                color: '#374151',
                                lineHeight: '1.5',
                                maxHeight: '120px',
                                overflowY: 'auto',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word'
                            }}>
                                {mensaje}
                            </div>
                        </div>

                        {detalle && (
                            <div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    marginBottom: '6px'
                                }}>
                                    <div style={{ fontSize: '12px', fontWeight: 600, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.4px' }}>Detalle</div>
                                    <button
                                        onClick={this.CopiarDetalle}
                                        style={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                            padding: '4px 10px',
                                            border: '1px solid #e5e7eb',
                                            borderRadius: '6px',
                                            background: this.state.Copied ? '#dcfce7' : '#ffffff',
                                            color: this.state.Copied ? '#166534' : '#6b7280',
                                            fontSize: '12px',
                                            fontWeight: 500,
                                            cursor: 'pointer',
                                            transition: 'all 0.15s ease',
                                            fontFamily: 'inherit'
                                        }}>
                                        <i className={`pi ${this.state.Copied ? 'pi-check' : 'pi-copy'}`} style={{ fontSize: '13px' }}></i>
                                        {this.state.Copied ? 'Copiado' : 'Copiar'}
                                    </button>
                                </div>
                                <div style={{
                                    padding: '12px 14px',
                                    background: '#f9fafb',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: '8px',
                                    fontSize: '13px',
                                    color: '#6b7280',
                                    lineHeight: '1.5',
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    whiteSpace: 'pre-wrap',
                                    wordBreak: 'break-word'
                                }}>
                                    {detalle}
                                </div>
                            </div>
                        )}
                    </div>
            </Dialog>
        )
    }
}
